"use strict";

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.EUnitOfTrim = exports.EFormatRestDurationType = exports.EFormatCountType = void 0;
exports.convertTimestamp = convertTimestamp;
exports.formatCount = void 0;
exports.formatDayOfWeek = formatDayOfWeek;
exports.formatDuration = formatDuration;
exports.formatDurationAdvanced = formatDurationAdvanced;
exports.formatPlayCount = formatPlayCount;
exports.formatRelativeTime = formatRelativeTime;
exports.formatRestDuration = formatRestDuration;
exports.formatRestDurationZH = formatRestDurationZH;
exports.formatUTCTime = formatUTCTime;
exports.formatUTCTimeBySeconds = formatUTCTimeBySeconds;
exports.ii = ii;
exports.padLeadingTrailingSpace = padLeadingTrailingSpace;

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/date/now"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/number/is-nan"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));

var _padStart = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/pad-start"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _lodash = require("lodash");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _moment = _interopRequireDefault(require("moment"));

var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context7, _context8; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context7 = ownKeys(Object(source), !0)).call(_context7, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { _Object$defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(0, _momentDurationFormat.default)(_moment.default);
var TEN_THOUSAND = 10000;
var ONE_MILLION = 1000000;
var ONE_HUNDRED_MILLION = 100000000; // 分数渲染为 xxxw 的最低分数要求

var DEFAULT_TRANSFORM_LIMIT = ONE_MILLION;
var DEFAULT_PRECISION = -3;
var EFormatCountType;
exports.EFormatCountType = EFormatCountType;

(function (EFormatCountType) {
  EFormatCountType["Up"] = "up";
  EFormatCountType["Down"] = "down";
  EFormatCountType["Round"] = "round";
})(EFormatCountType || (exports.EFormatCountType = EFormatCountType = {}));

var EFormatRestDurationType;
exports.EFormatRestDurationType = EFormatRestDurationType;

(function (EFormatRestDurationType) {
  EFormatRestDurationType["Days"] = "days";
  EFormatRestDurationType["Hours"] = "hours";
  EFormatRestDurationType["Minutes"] = "minutes";
})(EFormatRestDurationType || (exports.EFormatRestDurationType = EFormatRestDurationType = {}));

/**
 * 格式化数字，超出一定值之后进行缩写（除以一万，最多保留一位小数）
 * 默认为超过一百万后，分数除以一万，按四舍五入保留一位小数后，末尾追加 w（比如 100w）
 * @param count 分数
 * @param params 配置项
 */
var formatCount = function formatCount() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$limit = params.limit,
      limit = _params$limit === void 0 ? DEFAULT_TRANSFORM_LIMIT : _params$limit,
      _params$suffix = params.suffix,
      suffix = _params$suffix === void 0 ? 'w' : _params$suffix,
      _params$type = params.type,
      type = _params$type === void 0 ? EFormatCountType.Round : _params$type,
      _params$precision = params.precision,
      precision = _params$precision === void 0 ? DEFAULT_PRECISION : _params$precision;

  if (count >= limit) {
    var _context, _context2;

    var transformFn = _lodash.round;

    if (type === EFormatCountType.Up) {
      transformFn = _lodash.ceil;
    } else if (type === EFormatCountType.Down) {
      transformFn = _lodash.floor;
    } // eslint-disable-next-line no-magic-numbers


    var transformedNum = transformFn(count, precision);
    var divisor = Math.pow(10, -precision + 1);
    var integer = Math.floor(transformedNum / divisor);
    var decimal = '';
    var rest = transformedNum % divisor;

    if (rest > 0) {
      decimal = ".".concat((rest / 1000).toString()[0]);
    }

    return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(integer)).call(_context2, decimal)).call(_context, suffix);
  }

  return count;
};
/**
 * 字符串左补位
 *
 * @param s 原字符串或可安全转换为字符串的值
 * @param len 产生的字符串需要填充到的目标长度。如果这个数值小于当前字符串的长度，则返回当前字符串本身
 * @param pad 用于填充的字符串。如果该参数太长，使填充后的字符串长度超过了目标长度，则将该参数从右向左进行截断
 */


exports.formatCount = formatCount;

function ii(s) {
  var _context3;

  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var pad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return (0, _padStart.default)(_context3 = s.toString()).call(_context3, len, pad);
}
/**
 * 毫秒数格式化时间 支持中文（中文不显示秒）
 *
 * @param ms 毫秒
 * @param locale 中文或英文
 */


function formatDuration(ms) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  if (!ms) {
    return locale === 'zh' ? '--' : '00:00';
  } // `dayjs.duration.format` 格式化会返回求余后的数值，比如 `25:00:00` 会格式化成 `1:00:00`
  // 此处用手动格式化回避这个问题


  var dur = _dayjs.default.duration(ms); // `asHours` 获取总小时数，需要向下取整


  var h = Math.floor(dur.asHours());
  var m = dur.minutes();
  var s = dur.seconds();
  var formatter = {
    zh: function zh() {
      return (0, _lodash.compact)([h >= 1 && "".concat(h, " \u5C0F\u65F6"), "".concat(m, " \u5206")]).join(' ');
    },
    en: function en() {
      return (0, _lodash.compact)([h >= 1 && ii(h), ii(m), ii(s)]).join(':');
    }
  };
  return formatter[locale]();
}

var EUnitOfTrim;
exports.EUnitOfTrim = EUnitOfTrim;

(function (EUnitOfTrim) {
  EUnitOfTrim["Large"] = "large";
  EUnitOfTrim["Small"] = "small";
  EUnitOfTrim["Both"] = "both";
  EUnitOfTrim["Mid"] = "mid";
  EUnitOfTrim["Final"] = "final";
  EUnitOfTrim["All"] = "all";
})(EUnitOfTrim || (exports.EUnitOfTrim = EUnitOfTrim = {}));

/**
 * 秒数格式化函数，支持自定义格式化字符串
 * @param duration 持续时间
 * @param formatString 格式化字符串
 * @param [formatSettings] 格式化设置
 * @example
 * formatDurationAdvanced(60_000, 'H 小时 m 分钟 s 秒', { trim: 'small' }) // => '0 小时 1 分钟'
 * formatDurationAdvanced({ s: 60 }, 'H 小时 m 分钟 s 秒', { trim: 'large' }) // => '1 分钟 0 秒'
 * formatDurationAdvanced({ m: 1 }, 'H 小时 m 分钟 s 秒', { trim: 'both' }) // => '1 分钟'
 */
function formatDurationAdvanced(duration, formatString) {
  var _formatSettings$trim, _formatSettings$trunc;

  var formatSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _moment.default.duration(duration).format(formatString, {
    useGrouping: false,
    usePlural: false,
    trim: (_formatSettings$trim = (0, _trim.default)(formatSettings)) !== null && _formatSettings$trim !== void 0 ? _formatSettings$trim : EUnitOfTrim.Large,
    trunc: ((_formatSettings$trunc = formatSettings.trunc) !== null && _formatSettings$trunc !== void 0 ? _formatSettings$trunc : true) || undefined
  });
}
/**
 * 秒转换毫秒
 *
 * @param s 秒
 */


function convertTimestamp(s) {
  var time = typeof s === 'string' ? (0, _parseInt2.default)(s) : s;
  return time * 1000;
}
/**
 * 计算剩余时间，根据毫秒转换 天 时 分
 *
 * @param ms 毫秒
 */


function formatRestDurationZH(ms) {
  if ((0, _isNan.default)(ms)) {
    return '';
  }

  var restDuration = _dayjs.default.duration(ms);

  var days = Math.floor(restDuration.asDays());

  if (days > 0) {
    return "".concat(days, " \u5929");
  }

  var hours = Math.floor(restDuration.asHours());

  if (hours > 0) {
    return "".concat(hours, " \u5C0F\u65F6");
  } // 最少返回一分钟


  var minutes = Math.max(Math.floor(restDuration.asMinutes()), 1);
  return "".concat(minutes, " \u5206\u949F");
}
/**
 * 计算剩余时间，根据 type 进行区分，计算还剩多长时间（天，小时，分钟）
 *
 * @param ms 时间戳
 * @param type days | hours | minutes
 */


function formatRestDuration(ms, type) {
  if ((0, _isNan.default)(ms)) {
    return '';
  }

  return Math.round((0, _dayjs.default)(ms).diff((0, _dayjs.default)(), type, true));
}
/**
 * 根据传入的时间和格式，格式化时间
 *
 * @param ms 毫秒时间戳
 * @param formatString 格式化时间字符串 'YYYY-MM-DD HH:mm:ss'
 */


function formatUTCTime(ms, formatString) {
  if ((0, _isNan.default)(ms)) {
    return '';
  }

  return (0, _dayjs.default)(ms).format(formatString);
}
/**
 * 根据传入的时间和格式，格式化时间
 *
 * @param s 秒时间戳
 * @param formatString 格式化时间字符串 'YYYY-MM-DD HH:mm:ss'
 */


function formatUTCTimeBySeconds(s, formatString) {
  return formatUTCTime(s * 1000, formatString);
}

var dayOfWeekNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
/**
 * 格式化时间，如果传入的时间刚好是下一周，显示下周几，其他显示周几
 *
 * @param ms 时间戳
 * @param now 可以传入特定时间戳 默认当前时间
 */

function formatDayOfWeek(ms) {
  var _context4;

  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _now.default)();

  if ((0, _isNan.default)(ms)) {
    return '';
  }

  var time = (0, _dayjs.default)(ms);
  var prefix = (0, _dayjs.default)(now).add(1, 'week').isSame(time, 'isoWeek') ? '下' : '';
  var dayName = dayOfWeekNames[time.day()];
  return (0, _concat.default)(_context4 = "".concat(prefix)).call(_context4, dayName);
}
/**
 * 格式化时间
 * - `刚刚`: 60 秒内发布的内容
 * - `X 分钟前`: 60 秒至 60 分钟内发布的内容
 * - `X 小时前`: 60 分钟至 24 小时内发布的内容
 * - `昨天 HH:mm`: 昨天发布的内容，但又超过 24 小时了
 * - `MM-DD`: 昨天之前，今年发布的内容
 * - `YYYY-MM-DD`: 昨天之前，今年之前发布的内容
 * > 注意：循环内使用该方法请务必传 now 参数
 * @param timestamp 过去的时间戳（毫秒）
 * @param now 与过去的时间戳比较的目标时间戳（毫秒），默认是当前时间
 */


function formatRelativeTime(timestamp) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _now.default)();
  var sinceNow = now - timestamp;
  /* eslint-disable no-magic-numbers */

  if (sinceNow < 60000) {
    // 60 秒内发布的内容
    return '刚刚';
  }

  if (sinceNow < 3600000) {
    // 60 秒至 60 分钟内发布的内容
    return "".concat(Math.floor(sinceNow / 60000), " \u5206\u949F\u524D");
  }

  if (sinceNow < 86400000) {
    // 60 分钟至 24 小时内发布的内容
    return "".concat(Math.floor(sinceNow / 3600000), " \u5C0F\u65F6\u524D");
  }
  /* eslint-enable no-magic-numbers */


  var yesterday = (0, _dayjs.default)(now).startOf('day').subtract(1, 'days').valueOf();

  if (timestamp >= yesterday) {
    // 昨天发布的内容，但又超过 24 小时了
    return "\u6628\u5929 ".concat((0, _dayjs.default)(timestamp).format('HH:mm'));
  }

  var thisYear = (0, _dayjs.default)(now).startOf('year').valueOf();

  if (timestamp >= thisYear) {
    // 昨天之前，今年发布的内容
    return (0, _dayjs.default)(timestamp).format('MM-DD');
  } // 昨天之前，今年之前发布的内容


  return (0, _dayjs.default)(timestamp).format('YYYY-MM-DD');
}

/**
 * 当字符串的开头或结尾是英文或数字时，在开头或结尾填充空格
 * @example padLeadingTrailingSpace('hello') -> ' hello '
 * @example padLeadingTrailingSpace('thank you', { trailing: false }) -> ' thank you'
 * @example padLeadingTrailingSpace('thank you very much', { leading: false }) -> 'thank you very much '
 * @example padLeadingTrailingSpace('中文') -> '中文'
 */
function padLeadingTrailingSpace(text, padOpts) {
  var _context5, _context6;

  // 如果需要匹配 unicode 的字母和数字可以使用下面的 regex 并使用 `u` 作为 regex flag
  // https://www.unicode.org/reports/tr18/#word
  // '[\\p{Alphabetic}\\p{Decimal_Number}\\p{Mark}\\p{Connector_Punctuation}\\p{Join_Control}]'
  var opts = _objectSpread({
    leading: true,
    trailing: true
  }, padOpts);

  var leading = opts.leading && /^[0-9A-Za-z]/.test(text) ? ' ' : '';
  var trailing = opts.trailing && /[0-9A-Za-z]$/.test(text) ? ' ' : '';
  return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = "".concat(leading)).call(_context6, text)).call(_context5, trailing);
}
/**
 * 格式化播放量
 *
 * @param count 播放量
 * @example `${formatPlayCount(9999)}次播放` => '9999次播放'
 * @example `${formatPlayCount(109500000)}次播放` => '1.1 亿次播放'
 */


function formatPlayCount(count) {
  if (typeof count !== 'number' || (0, _isNan.default)(count)) {
    console.error('formatPlayCount expects count to be a number, but got', count);
    return '';
  }

  if (count < ONE_MILLION) {
    return "".concat(formatCount(count, {
      limit: TEN_THOUSAND,
      suffix: ' 万'
    }));
  }

  if (count >= ONE_MILLION && count < ONE_HUNDRED_MILLION) {
    return "".concat(Math.floor(count / TEN_THOUSAND), " \u4E07");
  }

  return "".concat((0, _lodash.round)(count / ONE_HUNDRED_MILLION, 2), " \u4EBF");
}